// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 23H3V1H21V23ZM11 17V19.0039H13.0039V17H11ZM9 5V7H15V5H9Z"}}]};

const TabletFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tablet-filled',
    ref,
    icon: element,
  },
));

TabletFilledIcon.displayName = 'TabletFilledIcon';

export default TabletFilledIcon;
